export enum Gender {
    Male = 'Male',
    Female = 'Female',
    NonBinary = 'Non Binary',
    NotDisclose = 'Not Disclose',
    SelfDescribe = 'Self Describe',
    Unknown = 'Unknown'
}
